import type { ReactNode } from 'react';

import { makeStyles } from '@mui/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';

import PathBanner from './PathBanner';

interface PathPromotionWrapperProps {
  children: ReactNode;
}

const useStyles = makeStyles(
  ({ breakpoints, spacing, palette }) => ({
    root: {
      background: palette.notification.neutral.background,
      padding: spacing(5, 0, 4),
      [breakpoints.up('sm')]: {
        padding: spacing(5, 0, 6),
      },
    },
  }),
  { classNamePrefix: 'PathPromotion' }
);

const PathPromotionWrapper = ({ children }: PathPromotionWrapperProps) => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <ContentWrapper>
        <PathBanner>{children}</PathBanner>
      </ContentWrapper>
    </section>
  );
};

export default PathPromotionWrapper;
